<template>
    <b-modal id="SuscriptionSelectedModal" v-model="display">

        <div slot="modal-title">{{ offer.planName }}</div>

        <b-img v-if="offer.imagenes_id" :src="offer.imagenes_id | img" class="mb-3" fluid />

        <div class="content-holder">
            <p class="content" v-html="markedDescription"></p>
            <div class="block mb-2">
                <b class="precio">{{ selectedPrice | currency }}</b>
                <template v-if="(offer.precio * 1) < (offer.precio_nominal * 1)">
                    <br> <b class="precio_nominal">{{ offer.precio_nominal | currency }}</b>
                </template>
            </div>
            <div class="stripeCardElementId-Class" :id="stripeCardElementId"></div>
            <pre v-if="debug">Offer:{{ offer }}</pre>
        </div>

        <div slot="modal-footer" class="gapper">
            <template v-if="!isProcessing">
                <b-button variant="warning" @click="display = false">Cancelar</b-button>
                <b-button variant="primary" @click="tryToStore">{{ nextLabel }}</b-button>
            </template>
            <b-button v-else class="btn btn-success" disabled>Procesando...</b-button>
        </div>

    </b-modal>

</template>

<script>

import stripeObj from '../stripeHandler.js';
import {notify} from '@/js/utils.js'
import sanitizeHtml from 'sanitize-html';
import axios from 'axios'

import { marked } from 'marked'

function emptyOffer() {
    return {
        imagenes_id: null,
        descr: null,
        precio: 0,
        precio_nominal: 0,
    }
}

export default {
    name: 'SuscriptionSelectedModal',
    props: {
        msisdn: {
            type: String,
            required: true
        },
        nextLabel: {
            type: String,
            default: 'Iniciar suscripción'
        },
        api2workWith: {
            type: String,
            default: 'suscripcion/start'
        },
        stripeCardElementId: {
            type: String,
            default: 'stripeCardElementId'
        },
        debug: {
            type: Boolean,
            default: false
        },
        nonSanitized: {
            type: Boolean,
            default: false
        }
    },
    data: () => {
        return {
            display: false,
            offer: emptyOffer(),
            stripe: null,
            stripeElements: null,
            stripeCardElement: null,
            stripePaymentMethod: null,
            paymentMethod: null,
            isProcessing: false
        }
    },
    computed: {
        selectedPrice() {
            return this.offer.precio;
        },
        markedDescription() {
            if (!this.offer.descr) {
                return ''
            } else {
                let html = (marked((this.offer.descr)))
                return (!this.nonSanitized) ? sanitizeHtml(html) : html;
            }
        }
    },
    methods: {
        async tryToStore() {
            this.isProcessing = true;
            let resp = false;
            try {
                let form = {
                    pm: await this.processPMObj(),
                    ofertaData: this.offer,
                    msisdn: this.msisdn,
                };
                console.log('tryToStore', form)
                resp = await axios.post(this.api2workWith, form);

                if(!_.isObjectLike(resp))
                    throw 'Error de red';

                if(resp.msg)
                    notify(resp.msg, resp.class);

                if (resp.status)
                    this.$emit('success', resp.data)
                else
                    this.$emit('error', resp.data)
            } catch (e) {
                alert(e)
            }
            this.isProcessing = false;
            return resp;
        },
        async processPMObj() {

            const result = await this.stripe.createPaymentMethod({
                type: 'card',
                card: this.stripeCardElement,
            })

            if (result.error) {
                // Handle error
                this.paymentMethod = null;
                console.warn(result.error)
                throw result.error.message;
            } else {
                // PaymentMethod created successfully
                console.log(result.paymentMethod);
                this.paymentMethod = result.paymentMethod;
                // Send paymentMethod.id to your server
            }
            return this.paymentMethod;
        },
        loadPaymentElements() {
            if (!this.stripe)
                this.stripe = stripeObj.initialize()
            this.stripeElements = this.stripe.elements({
                mode: 'subscription',
                currency: 'mxn',
                amount: (this.selectedPrice * 100)
            });
            this.stripeCardElement = this.stripeElements.create('card', { style: stripeObj.style });
            setTimeout(() => {
                this.stripeCardElement.mount('#' + this.stripeCardElementId);
            }, 100)
        },
        resetStripe() {
            this.stripe = stripeObj.initialize();
            this.stripeElements = null;
            this.stripeCardElement = null;
        },
        openWithOffer(offer) {
            this.offer = (offer);
            this.display = true;
            this.resetStripe();
            if (this.display)
                this.$nextTick(this.loadPaymentElements)
            // else 
            // this.resetStripe()
        }
    },

}

</script>

<style lang="scss">
@import "../../../../../sass/utils/_variables.scss";

#SuscriptionSelectedModal {
    .gapper {
        display: flex;
        flex-flow: row;
        gap: 16px;
    }

    .modal-body {
        padding: 0;
        color: $white;
        background-color: $primary-dark;
    }

    .content {
        &-holder {
            padding: 1rem;
        }

        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            color: $accent;
        }
    }

    b, strong {
        color: $primary-light;
        font-weight: 600;
    }

    .precio {
        font-size: 1.5em;

        &_nominal {
            color: $danger;
        }
    }
}
</style>